import React from 'react';
import { CircleAlertIcon } from 'lucide-react';
import { Section } from './Section';
const SITUATIONS = ['Usás tu iPhone solo para WhatsApp, llamadas, cámara y redes.', 'Te da miedo tocar configuraciones por si desconfigurás algo.', 'La batería te dura poco y no sabés por qué.', 'iCloud, AirDrop, Face ID y Atajos te suenan, pero no los usás.', 'Sentís que pagaste mucho por un celular que usás al 20%.'];
export function ProblemSection() {
  return <Section className="bg-ink-950" data-id="element-235" data-mp="39jqoi9h8i7gt">
      <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-accent-soft" data-id="element-236" data-mp="35h2alndnyacz">
        La realidad de tener un iPhone
      </p>
      <h2 className="text-3xl font-extrabold leading-[1.15] tracking-tight text-white sm:text-4xl" data-id="element-237" data-mp="3jfadebxds5w2">
        ¿Te suena familiar?
      </h2>

      <ul className="mt-8 grid gap-2.5 sm:grid-cols-2" data-id="element-238" data-mp="1p1ssyxs9vp59">
        {SITUATIONS.map(item => <li key={item} className="flex gap-3 rounded-2xl border border-white/8 bg-ink-900 px-5 py-4 text-sm leading-relaxed text-white/70" data-id="element-239" data-mp="1k37p8odtanc2">
            <CircleAlertIcon className="mt-0.5 h-4 w-4 shrink-0 text-white/30" aria-hidden="true" data-id="element-240" data-mp="jbag56hhxnid" />
            <span data-id="element-241" data-mp="sdjmdk5qeupy">{item}</span>
          </li>)}
      </ul>

      <p className="mt-6 text-sm leading-relaxed text-white/60 sm:text-base" data-id="element-242" data-mp="x4i5ssm0o8xf">
        No es que seas malo con la tecnología: nunca tuviste una guía completa,
        ordenada y fácil de entender. Hasta ahora.
      </p>
    </Section>;
}